import React, { Fragment } from 'react'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import { ApexChartTitle, ChartsTitle } from '../../../Utils/Constants'
import { Container, Row } from 'reactstrap'
import BasicAreaChart from './BasicAreaChart'
import AreaSpalineChart from './AreaSpalineChart'
import BarChart from './BarChart'
import ColumnChart from './ColumnChart'
import BubbleChart from './BubbleChart'
import SteplineChart from './SteplineChart'
import LineChart from './LineChart'
import MixedChart from './MixedChart'
import CandlestickChart from './CandlestickChart'
import RadarChart from './RadarChart'
import RadialBarChart from './RadialBarChart'

export default function ApexChartContainer() {
    
    return (
        <Fragment>
            <Breadcrumbs pageTitle={ApexChartTitle} parent={ChartsTitle} title={ApexChartTitle} />
            <Container fluid>
                <Row>
                    <BasicAreaChart />
                    <AreaSpalineChart />
                    <BarChart />
                    <ColumnChart />
                    <BubbleChart />
                    <SteplineChart />
                    <LineChart />
                    <MixedChart/>
                    <CandlestickChart/>
                    <RadarChart/>
                    <RadialBarChart/>
                </Row>
            </Container>
        </Fragment>
    )
}
